/**
 */

define('directives/myservices/accessMode/accessMode.directives',['app', 'mainCons'], function (app, mainCons) {
    app.directive('accountaccessMode', ['HuaweiTrade', 'OpenApp', 'auiDialog', '$filter', function (HuaweiTrade, OpenApp, auiDialog, $filter) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/myservices/accessMode/accessMode.html',
            link: function ($scope, $element, attrs, ngModelCtrl) {
                $scope.Model.accessModeType = [
                    {value: 1, name: 'SDK接入', flag: true},
                    {value: 2, name: 'JS-SDK接入', flag: false}
                ];
                if ($scope.Model.product.isUpdate) {
                    var queryParam = {
                        request: {
                            prodID: $scope.Model.product.prodID,
                            prodType: $scope.Model.product.prodType,
                        }
                    };
                    //查询类别prodID，parentType
                    OpenApp.getServiceList(queryParam).then(function (res) {
                        if (res.resultCode == 0) {

                            for (var i in res.serviceList) {
                                if (res.serviceList[i].serviceItem == $scope.Model.serviceItem) {
                                    if (res.serviceList[i].serviceAttrs && angular.fromJson(res.serviceList[i].serviceAttrs).accessMode) {
                                        var accessMode = angular.fromJson(res.serviceList[i].serviceAttrs).accessMode;


                                        for (var x in $scope.Model.accessModeType) {
                                            if (AUI.BaseJSUtil.contains(accessMode, $scope.Model.accessModeType[x].value)) {
                                                $scope.Model.accessModeType[x].flag = true;
                                            }
                                        }
                                    }

                                }
                            }
                        }
                    });
                }

                $scope.adaptEquip = function (adapt) {
                    if (adapt.name === 'SDK接入') {
                        return;
                    }
                    else {
                        adapt.flag = !adapt.flag;
                    }

                };

                //控制选中未选中的样式
                $scope.showAdaptClass = function (adapt) {
                    if (adapt.name === 'SDK接入') {
                        return 'disable';
                    }
                    else {
                        if (adapt.flag) {
                            return 'checked';
                        }
                        else {
                            return 'unchecked';
                        }

                    }

                };
            }
        }
    }]);
});
